/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import '@babel/polyfill';

// Import all the third party stuff
import React from 'react';
import App from './containers/App';

export default function mount() {
  console.log('Dashboard mounted 1');
  return (
      <App />
  );
}
